var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"row justify-content-between button-tipo-preco",on:{"click":function($event){return _vm.$emit('click')}}},[_vm._v(" "+_vm._s(_vm.title)+" "),_c('b-icon',{attrs:{"icon":_vm.opened ? 'chevron-down' : 'chevron-up'}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }